import $ from 'jquery';
$(document).ready(function() {
    const calendar = $('#cSchedule');
    if (calendar.length > 0) {
        const schedule = $('#cSchedule');
        $(document).on('click', '.scheduleTab > span', function() {
            $('.scheduleTab > span').removeClass('current');
            $(this).addClass('current');
            if ($(this).hasClass('list_table')) {
                calendar.addClass('list');
            } else {
                calendar.removeClass('list');
            }
        });

        function removeCellsTables() {
            let cellTablesEmpty = $('.cScheduleItem.not_cells');
            if (cellTablesEmpty.length >= 7) {
                cellTablesEmpty.slice(-7).remove();
            }
        }
        removeCellsTables();

        function getMonthAjax(month) {
            $.ajax({
                url: calendar.data('href'),
                data: {
                    'month': month
                },
                success: function(response) {
                    if (response.status == 200) {
                        schedule.html(response.data);
                        processAjaxData(response.data, month);
                        removeCellsTables();
                    }
                },
            });
        }

        function addCurentCalender() {
            let table = $('.table_calendar');
            let list_table = $('.list_table');
            window.innerWidth <= 768 ? list_table.addClass('current') : table.addClass('current');
        }

        $(document).on('click', '.cScheduleNext', function() {
            let cScheduleNext = $(this).data('month');
            getMonthAjax(cScheduleNext)
        });

        $(document).on('click', '.cSchedulePrev', function() {
            let sChedulePrev = $(this).data('month');
            getMonthAjax(sChedulePrev);
        });

        addCurentCalender();

        function processAjaxData(html, month) {
            let url = $('#cSchedule').data('href-calendar') + `?month=${month}`;
            window.history.pushState({ "html": html }, "", url);
        }
        window.onpopstate = function(e) {
            if (e.state) {
                schedule.html(e.state.html);
            }
        };
        processAjaxData(schedule.html(), $('.cScheduleYear').data('month'));
    }
});